import * as React from 'react';
import type { SVGProps } from 'react';
const SvgPivotTable = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={33}
    height={28}
    fill="none"
    {...props}
  >
    <path
      fill="#fff"
      d="M2.729 5.931h27.54V24.08a.893.893 0 0 1-.888.898H3.617a.893.893 0 0 1-.888-.898z"
    />
    <path
      fill="#C2C8D3"
      fillRule="evenodd"
      d="M29.825 6.38H3.173v17.7c0 .247.2.448.444.448h25.764a.447.447 0 0 0 .444-.448zM2.729 5.931V24.08c0 .496.398.898.888.898h25.764c.49 0 .888-.402.888-.898V5.931z"
      clipRule="evenodd"
    />
    <path fill="#E0E3E9" d="M13.39 24.533V5.9h.724v18.633z" />
    <path
      fill="#E0E3E9"
      d="M2.729 12.083c0-.162.13-.293.29-.293h26.96c.16 0 .29.131.29.293v.147c0 .161-.13.293-.29.293H3.019a.29.29 0 0 1-.29-.293z"
    />
    <path
      fill="#E0E3E9"
      d="M21.675 24.977a.29.29 0 0 1-.29-.293V6.224c0-.162.13-.293.29-.293h.145c.16 0 .29.131.29.293v18.46c0 .162-.13.293-.29.293z"
    />
    <path
      fill="#E0E3E9"
      d="M2.729 18.677c0-.162.13-.293.29-.293h26.96c.16 0 .29.131.29.293v.146c0 .162-.13.293-.29.293H3.019a.29.29 0 0 1-.29-.293z"
    />
    <path
      fill="#729FF9"
      d="M2.729 3.733c0-.405.324-.733.724-.733h26.09a.73.73 0 0 1 .726.733V5.93H2.729z"
    />
    <path
      fill="#C2C8D3"
      fillRule="evenodd"
      d="M29.824 6.38H3.173v17.7c0 .247.199.448.444.448H29.38a.447.447 0 0 0 .444-.448zM2.73 5.931V24.08c0 .496.397.898.888.898H29.38c.49 0 .889-.402.889-.898V5.931H2.729Z"
      clipRule="evenodd"
    />
    <path
      fill="#729FF9"
      d="M3.617 25a.893.893 0 0 1-.888-.898V6.367h3.393V25z"
    />
  </svg>
);
export default SvgPivotTable;
